

























import { Component, Prop, Vue } from "vue-property-decorator";
import ResumeProject from "./ResumeProject.vue";
import { Project } from "./Project";

@Component({
    components: {
        ResumeProject
    }
})
export default class ResumeProjects extends Vue {
    @Prop() private title!: string;
    @Prop() private projects!: Project[];
}
